import classNames from 'classnames';

export const logoWrapperClasses = classNames(
  'flex mt-1',
  'absolute left-1/2 -translate-x-1/2',
  'md:static md:translate-x-0 md:mr-auto'
);

export const headerLinksWrapperClasses = classNames(
  'flex flex-row items-center',
  'gap-0 md:gap-4',
  'text-base font-medium'
);

export const signInWrapperClasses = classNames(
  'flex flex-col items-center',
  'gap-0',
  'absolute right-4 top-1/2 -translate-y-1/2',
  'md:flex-row md:gap-[10px] md:static md:translate-y-0'
);

export const signInButtonWrapperClasses = classNames(
  'flex flex-col',
  'text-white font-medium text-xs md:text-base'
);

export const getHeaderClasses = (isDarkMode: boolean) =>
  classNames(
    'flex items-center relative justify-center',
    'h-[50px] px-4',
    'md:justify-between desktop:px-6',
    isDarkMode ? 'bg-secondary-dark' : 'bg-digital-walmart-blue'
  );

export const desktopTextClasses = classNames('font-bold text-base text-white');

export const signInButtonImageWrapperClasses = classNames('-mb-0.5');

export const ctaClasses = classNames('hidden md:block');
